// extracted by mini-css-extract-plugin
export default {"three_dot_loader":"styles_three_dot_loader__-BN6t","dotLoaderAnimation":"styles_dotLoaderAnimation__8FHo8"};